import { render } from "./qita.vue?vue&type=template&id=40728534&scoped=true"
import script from "./qita.vue?vue&type=script&lang=js"
export * from "./qita.vue?vue&type=script&lang=js"

import "./qita.vue?vue&type=style&index=0&id=40728534&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Administrator\\work\\zhongsheng\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40728534"]])

export default __exports__